import React, { isValidElement } from 'react';
import RichText from '../RichText/RichText';
// A utility component that takes contentful rich text, styled JSX, or a string, and returns it as a react element
var TextToJSX = function (_a) {
    var text = _a.text, _b = _a.config, config = _b === void 0 ? undefined : _b, _c = _a.headerStyle, headerStyle = _c === void 0 ? 'SERIF' : _c, lightHexCode = _a.lightHexCode, headerMaxLineLength = _a.headerMaxLineLength, _d = _a.bulletType, bulletType = _d === void 0 ? 'DEFAULT_BULLET' : _d, _e = _a.listStyle, listStyle = _e === void 0 ? 'ONE_COLUMN' : _e;
    var isContentfulRichText = typeof text === 'object' && text.nodeType && text.data && text.content;
    if (isContentfulRichText) {
        return (React.createElement(RichText, { richText: text, config: config, headerStyle: headerStyle, lightHexCode: lightHexCode, headerMaxLineLength: headerMaxLineLength, bulletType: bulletType, listStyle: listStyle }));
    }
    if (typeof text === 'string' || isValidElement(text)) {
        return React.createElement(React.Fragment, null, text);
    }
    return null;
};
export default TextToJSX;
